import { render, staticRenderFns } from "./StethoscopeIcon.vue?vue&type=template&id=c15cf4e0&scoped=true&"
import script from "./StethoscopeIcon.vue?vue&type=script&setup=true&lang=ts&"
export * from "./StethoscopeIcon.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c15cf4e0",
  null
  
)

export default component.exports